/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc
 */
import * as References from './ProductRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getProducts
 */
export const GET_PRODUCTS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getProducts';
export const GET_PRODUCTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PRODUCTS_QUERY_FIELD_NAME,
  args: ['productApiNames'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getProductsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getProductsV2
 */
export const GET_PRODUCTS_V2_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getProductsV2';
export const GET_PRODUCTS_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PRODUCTS_V2_QUERY_FIELD_NAME,
  args: ['productApiNames'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getProductsV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getProductInventory
 */
export const GET_PRODUCT_INVENTORY_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getProductInventory';
export const GET_PRODUCT_INVENTORY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PRODUCT_INVENTORY_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getProductInventoryRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getProductInventoryV2
 */
export const GET_PRODUCT_INVENTORY_V2_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getProductInventoryV2';
export const GET_PRODUCT_INVENTORY_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PRODUCT_INVENTORY_V2_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getProductInventoryV2Rpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getSeatsProductInventoryV2
 */
export const GET_SEATS_PRODUCT_INVENTORY_V2_MUTATION_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getSeatsProductInventoryV2';
export const GET_SEATS_PRODUCT_INVENTORY_V2_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: GET_SEATS_PRODUCT_INVENTORY_V2_MUTATION_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getSeatsProductInventoryV2Rpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getOwnedProducts
 */
export const GET_OWNED_PRODUCTS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getOwnedProducts';
export const GET_OWNED_PRODUCTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_OWNED_PRODUCTS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getOwnedProductsRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getAddOns
 */
export const GET_ADD_ONS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getAddOns';
export const GET_ADD_ONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ADD_ONS_QUERY_FIELD_NAME,
  args: ['productApiNames'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getAddOnsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getAddOnsV2
 */
export const GET_ADD_ONS_V2_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getAddOnsV2';
export const GET_ADD_ONS_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ADD_ONS_V2_QUERY_FIELD_NAME,
  args: ['productApiNames'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.getAddOnsV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getGrowthPurchaseOptions
 */
export const GET_GROWTH_PURCHASE_OPTIONS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getGrowthPurchaseOptions';
export const GET_GROWTH_PURCHASE_OPTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_GROWTH_PURCHASE_OPTIONS_QUERY_FIELD_NAME,
  args: ['products', 'currencyCode', 'preferredCountry', 'browserLocale'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getGrowthPurchaseOptionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getGrowthPurchaseOptionsV2
 */
export const GET_GROWTH_PURCHASE_OPTIONS_V2_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getGrowthPurchaseOptionsV2';
export const GET_GROWTH_PURCHASE_OPTIONS_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_GROWTH_PURCHASE_OPTIONS_V2_QUERY_FIELD_NAME,
  args: ['products', 'currencyCode', 'preferredCountry', 'browserLocale'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.getGrowthPurchaseOptionsV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getOwnedQuantities
 */
export const GET_OWNED_QUANTITIES_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getOwnedQuantities';
export const GET_OWNED_QUANTITIES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_OWNED_QUANTITIES_QUERY_FIELD_NAME,
  args: ['quantityNames'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.getOwnedQuantitiesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getOwnedQuantitiesV2
 */
export const GET_OWNED_QUANTITIES_V2_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getOwnedQuantitiesV2';
export const GET_OWNED_QUANTITIES_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_OWNED_QUANTITIES_V2_QUERY_FIELD_NAME,
  args: ['quantityNames'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.getOwnedQuantitiesV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getCurrency
 */
export const GET_CURRENCY_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getCurrency';
export const GET_CURRENCY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CURRENCY_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.getCurrencyRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getCurrencyV2
 */
export const GET_CURRENCY_V2_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getCurrencyV2';
export const GET_CURRENCY_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CURRENCY_V2_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient14;
    return ((_ctx$customClient14 = ctx.customClient) !== null && _ctx$customClient14 !== void 0 ? _ctx$customClient14 : chirpClient).call(References.getCurrencyV2Rpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getFeatureFlags
 */
export const GET_FEATURE_FLAGS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getFeatureFlags';
export const GET_FEATURE_FLAGS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_FEATURE_FLAGS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient15;
    return ((_ctx$customClient15 = ctx.customClient) !== null && _ctx$customClient15 !== void 0 ? _ctx$customClient15 : chirpClient).call(References.getFeatureFlagsRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getFeatureFlagsV2
 */
export const GET_FEATURE_FLAGS_V2_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getFeatureFlagsV2';
export const GET_FEATURE_FLAGS_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_FEATURE_FLAGS_V2_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient16;
    return ((_ctx$customClient16 = ctx.customClient) !== null && _ctx$customClient16 !== void 0 ? _ctx$customClient16 : chirpClient).call(References.getFeatureFlagsV2Rpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getInAppPhoneNumber
 */
export const GET_IN_APP_PHONE_NUMBER_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getInAppPhoneNumber';
export const GET_IN_APP_PHONE_NUMBER_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_IN_APP_PHONE_NUMBER_QUERY_FIELD_NAME,
  args: ['preferredLanguage'],
  fetcher(request, ctx) {
    var _ctx$customClient17;
    return ((_ctx$customClient17 = ctx.customClient) !== null && _ctx$customClient17 !== void 0 ? _ctx$customClient17 : chirpClient).call(References.getInAppPhoneNumberRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getInAppProductBadges
 */
export const GET_IN_APP_PRODUCT_BADGES_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getInAppProductBadges';
export const GET_IN_APP_PRODUCT_BADGES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_IN_APP_PRODUCT_BADGES_QUERY_FIELD_NAME,
  args: ['productApiNames', 'seatCount'],
  fetcher(request, ctx) {
    var _ctx$customClient18;
    return ((_ctx$customClient18 = ctx.customClient) !== null && _ctx$customClient18 !== void 0 ? _ctx$customClient18 : chirpClient).call(References.getInAppProductBadgesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getInAppProductTierOptions
 */
export const GET_IN_APP_PRODUCT_TIER_OPTIONS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getInAppProductTierOptions';
export const GET_IN_APP_PRODUCT_TIER_OPTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_IN_APP_PRODUCT_TIER_OPTIONS_QUERY_FIELD_NAME,
  args: ['browserLocale', 'currencyCode', 'teamSizeConfiguration', 'contactQuantity', 'selectedUseCaseGroups', 'activeFeatureFlags'],
  fetcher(request, ctx) {
    var _ctx$customClient19;
    return ((_ctx$customClient19 = ctx.customClient) !== null && _ctx$customClient19 !== void 0 ? _ctx$customClient19 : chirpClient).call(References.getInAppProductTierOptionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getInAppProductPlan
 */
export const GET_IN_APP_PRODUCT_PLAN_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getInAppProductPlan';
export const GET_IN_APP_PRODUCT_PLAN_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_IN_APP_PRODUCT_PLAN_QUERY_FIELD_NAME,
  args: ['productCart', 'browserLocale', 'currencyCode', 'contactQuantity', 'selectedUseCaseGroups'],
  fetcher(request, ctx) {
    var _ctx$customClient20;
    return ((_ctx$customClient20 = ctx.customClient) !== null && _ctx$customClient20 !== void 0 ? _ctx$customClient20 : chirpClient).call(References.getInAppProductPlanRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getPortalStateWithUsage
 */
export const GET_PORTAL_STATE_WITH_USAGE_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getPortalStateWithUsage';
export const GET_PORTAL_STATE_WITH_USAGE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PORTAL_STATE_WITH_USAGE_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient21;
    return ((_ctx$customClient21 = ctx.customClient) !== null && _ctx$customClient21 !== void 0 ? _ctx$customClient21 : chirpClient).call(References.getPortalStateWithUsageRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getInAppProductConfig
 */
export const GET_IN_APP_PRODUCT_CONFIG_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getInAppProductConfig';
export const GET_IN_APP_PRODUCT_CONFIG_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_IN_APP_PRODUCT_CONFIG_QUERY_FIELD_NAME,
  args: ['browserLocale'],
  fetcher(request, ctx) {
    var _ctx$customClient22;
    return ((_ctx$customClient22 = ctx.customClient) !== null && _ctx$customClient22 !== void 0 ? _ctx$customClient22 : chirpClient).call(References.getInAppProductConfigRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getProductUseCases
 */
export const GET_PRODUCT_USE_CASES_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getProductUseCases';
export const GET_PRODUCT_USE_CASES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PRODUCT_USE_CASES_QUERY_FIELD_NAME,
  args: ['browserLocale', 'useCaseGroups'],
  fetcher(request, ctx) {
    var _ctx$customClient23;
    return ((_ctx$customClient23 = ctx.customClient) !== null && _ctx$customClient23 !== void 0 ? _ctx$customClient23 : chirpClient).call(References.getProductUseCasesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getInAppRecommendations
 */
export const GET_IN_APP_RECOMMENDATIONS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getInAppRecommendations';
export const GET_IN_APP_RECOMMENDATIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_IN_APP_RECOMMENDATIONS_QUERY_FIELD_NAME,
  args: ['browserLocale', 'currencyCode'],
  fetcher(request, ctx) {
    var _ctx$customClient24;
    return ((_ctx$customClient24 = ctx.customClient) !== null && _ctx$customClient24 !== void 0 ? _ctx$customClient24 : chirpClient).call(References.getInAppRecommendationsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#rejectInAppRecommendation
 */
export const REJECT_IN_APP_RECOMMENDATION_MUTATION_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_rejectInAppRecommendation';
export const REJECT_IN_APP_RECOMMENDATION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REJECT_IN_APP_RECOMMENDATION_MUTATION_FIELD_NAME,
  args: ['recommendationId'],
  fetcher(request, ctx) {
    var _ctx$customClient25;
    return ((_ctx$customClient25 = ctx.customClient) !== null && _ctx$customClient25 !== void 0 ? _ctx$customClient25 : chirpClient).call(References.rejectInAppRecommendationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#clickedInAppRecommendation
 */
export const CLICKED_IN_APP_RECOMMENDATION_MUTATION_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_clickedInAppRecommendation';
export const CLICKED_IN_APP_RECOMMENDATION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CLICKED_IN_APP_RECOMMENDATION_MUTATION_FIELD_NAME,
  args: ['recommendationId'],
  fetcher(request, ctx) {
    var _ctx$customClient26;
    return ((_ctx$customClient26 = ctx.customClient) !== null && _ctx$customClient26 !== void 0 ? _ctx$customClient26 : chirpClient).call(References.clickedInAppRecommendationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#getInAppGrowthPurchaseOptionsForCart
 */
export const GET_IN_APP_GROWTH_PURCHASE_OPTIONS_FOR_CART_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_getInAppGrowthPurchaseOptionsForCart';
export const GET_IN_APP_GROWTH_PURCHASE_OPTIONS_FOR_CART_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_IN_APP_GROWTH_PURCHASE_OPTIONS_FOR_CART_QUERY_FIELD_NAME,
  args: ['products', 'currencyCode'],
  fetcher(request, ctx) {
    var _ctx$customClient27;
    return ((_ctx$customClient27 = ctx.customClient) !== null && _ctx$customClient27 !== void 0 ? _ctx$customClient27 : chirpClient).call(References.getInAppGrowthPurchaseOptionsForCartRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc#prefetchPortal
 */
export const PREFETCH_PORTAL_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_ProductRpc_prefetchPortal';
export const PREFETCH_PORTAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: PREFETCH_PORTAL_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient28;
    return ((_ctx$customClient28 = ctx.customClient) !== null && _ctx$customClient28 !== void 0 ? _ctx$customClient28 : chirpClient).call(References.prefetchPortalRpc, {
      timeout: ctx.timeout
    });
  }
});